<footer class="app-footer" id="app-footer">
  <span class="float-right"><span class="text-primary">{{appName}}</span> | Powered by Shift Digital - &copy; {{currentYear}} Shift Digital</span>
</footer>
